import { Link, animateScroll as scroll } from "react-scroll";

export default function HeroSection() {
  const scrollToContact = () => {
    scroll.scrollTo("Contact", {
      duration: 500,
      smooth: true,
      offset: -70,
      spy: true,
      activeClass: "navbar--active-content",
    });
  };
  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title">Hello, I am Chris Chau, and I am a </p>
          <h1 className="hero--section--title">
            <span className="hero--section--title--color">Software</span>{" "}
            <br />
            Developer
          </h1>
          <p className="hero--section-description">
            I specialize in full-stack development and AI-powered applications. 
            <br /> Currently leading AI development at More Good Foundation, crafting intelligent solutions with modern technologies. <br />
          </p>
        </div>
        
        <Link
          to="Contact"
          spy={true}
          smooth={true}
          duration={500}
          offset={-70}
          activeClass="navbar--active-content"
        >
          <button className="btn btn-primary" onClick={scrollToContact}>
            Get In Touch
          </button>
        </Link>
      </div>
      <div className="hero--section--img">
        <img src="./img/avatar.jpg" alt="Hero Section" />
      </div>
    </section>
  );
}
